export type CampaignDataTabMessages = {
  campaignInformationTitle: string;
  contactInformationTitle: string;
  productInformationTitle: string;
  campaignSchedulingTitle: string;
  introductionTitle: string;

  campaignCodeLabel: string;
  campaignNameLabel: string;
  campaignTypeLabel: string;
  discountPercentageLabel: string;
  startValidityDateLabel: string;
  endValidityDateLabel: string;
  introductionTextLabel: string;
  triggerDaysAndTimesLabel: string;
  statusLabel: string;
  addCampaignImageLabel: string;

  errorRequiredCampaignCode: string;
  errorRequiredCampaignName: string;
  errorRequiredCampaignType: string;
  errorRequiredDiscountPercentage: string;
  errorRequiredStartValidityDate: string;
  errorRequiredEndValidityDate: string;
  errorRequiredIntroductionText: string;
  errorRequiredTriggerDaysAndTimes: string;
  errorRequiredStatus: string;
  errorRequiredSchedules: string;

  // Error messages for discount validation
  errorMinDiscountPercentage: string;
  errorMaxDiscountPercentage: string;
  errorZeroPromoPrice: string;

  // Error messages for date validation
  errorRequiredStartDate: string;
  errorRequiredEndDate: string;
  errorEndDateBeforeStartDate: string;
  errorZeroDiscountForCoupon: string;

  // Error messages for product validation
  errorRequiredMinQuantity: string;
  errorRequiredPromoPrice: string;
  errorPromoPriceMustBeGreaterThanZero: string;

  // Error messages for age validation
  errorMinAgeNegative: string;
  errorMinAgeTooHigh: string;
  errorMaxAgeTooLow: string;
  errorMaxAgeTooHigh: string;
  errorRequiredMinimumAge: string;

  schedulingImmediateSwitchLabel: string;
  schedulingImmediateSwitchDescription: string;
  schedulingImmediateSwitchHelper: string;
  schedulingHoursTitle: string;
  schedulingHoursDescription: string;
  schedulingCustomHourLabel: string;
  schedulingWeekDaysTitle: string;
  schedulingWeekDaysDescription: string;
  schedulingSpecificDaysTitle: string;
  schedulingSpecificDaysDescription: string;
  schedulingAddSpecificDateLabel: string;
  schedulingProgrammedDatesTitle: string;
  schedulingProgrammedDatesDescription: string;
  schedulingAddProgrammedDateLabel: string;
  schedulingFixedTimeLabel: string;
  schedulingApplyButtonLabel: string;
  schedulingGeneratedDatesTitle: string;
  schedulingAddButtonLabel: string;
  schedulingClearSchedulesButtonLabel: string;
  schedulingAddNewSendsTitle: string;
  schedulingNoSchedulingConfiguredError: string;
  schedulingNoDaysSelectedError: string;
  schedulingNoHoursSelectedError: string;
  schedulingDateInPastError: string;
  schedulingAllDatesInPastError: string;
  schedulingDateOutOfRangeError: string;
};

export const CAMPAIGN_DATA_TAB_MESSAGES: CampaignDataTabMessages = {
  // Titles
  campaignInformationTitle: "Informações da Campanha",
  contactInformationTitle: "Segmentação",
  productInformationTitle: "Informações de Produtos",
  campaignSchedulingTitle: "Agendamento da Campanha",
  introductionTitle: "Mensagem da campanha",

  // Labels
  campaignCodeLabel: "Código",
  campaignNameLabel: "Nome",
  campaignTypeLabel: "Tipo",
  discountPercentageLabel: "Desconto (%)",
  startValidityDateLabel: "Vigência Inícial",
  endValidityDateLabel: "Vigência Final",
  introductionTextLabel: "Mensagem",
  triggerDaysAndTimesLabel: "Dia e Hora de Disparo",
  statusLabel: "Status",
  addCampaignImageLabel: "Adicione a Imagem da Campanha",

  // Error messages
  errorRequiredCampaignCode: "O código da campanha é obrigatório!",
  errorRequiredCampaignName: "O nome da campanha é obrigatório!",
  errorRequiredCampaignType: "O tipo da campanha é obrigatório!",
  errorRequiredDiscountPercentage: "O desconto é obrigatório para o tipo de campanha selecionado!",
  errorRequiredStartValidityDate: "A data de início da validade é obrigatória!",
  errorRequiredEndValidityDate: "A data de fim da validade é obrigatória!",
  errorRequiredIntroductionText: "O texto de introdução é obrigatório!",
  errorRequiredTriggerDaysAndTimes: "Os dias e horários de disparo são obrigatórios!",
  errorRequiredStatus: "O status da campanha é obrigatório!",
  errorRequiredSchedules: "Data de disparo é obrigatória!",

  // Error messages for discount validation
  errorMinDiscountPercentage: "O desconto não pode ser menor que 0%.",
  errorMaxDiscountPercentage: "O desconto não pode ser maior que 100%.",
  errorZeroPromoPrice:
    "O preço promocional não pode ser zero. Por favor, verifique os produtos da campanha.",

  // Error messages for date validation
  errorRequiredStartDate: "A data de início é obrigatória!",
  errorRequiredEndDate: "A data de fim é obrigatória!",
  errorEndDateBeforeStartDate: "A data de fim não pode ser anterior à data de início!",
  errorZeroDiscountForCoupon: "O desconto para cupons não pode ser zero.",

  // Error messages for product validation
  errorRequiredMinQuantity: "A quantidade mínima é obrigatória!",
  errorRequiredPromoPrice: "O preço promocional é obrigatório!",
  errorPromoPriceMustBeGreaterThanZero: "O preço promocional deve ser maior que zero!",

  // Error messages for age validation
  errorMinAgeNegative: "A idade mínima não pode ser negativa!",
  errorMinAgeTooHigh: "A idade mínima não pode ser maior que 120!",
  errorMaxAgeTooLow: "A idade máxima não pode ser menor que a idade mínima!",
  errorMaxAgeTooHigh: "A idade máxima não pode ser maior que 120!",
  errorRequiredMinimumAge: "A idade mínima é obrigatória quando a idade máxima é informada.",

  schedulingImmediateSwitchLabel: "Envio Imediato",
  schedulingImmediateSwitchDescription: "A campanha será enviada imediatamente após a criação",
  schedulingImmediateSwitchHelper:
    "💡 Desabilite essa opção para segmentar os horários e datas de envio da campanha",
  schedulingHoursTitle: "Horários de Envio",
  schedulingHoursDescription: "Defina os horários em que as mensagens podem ser enviadas",
  schedulingCustomHourLabel: "Horário personalizado",
  schedulingWeekDaysTitle: "Dias da Semana",
  schedulingWeekDaysDescription: "Selecione os dias da semana em que a campanha pode ser enviada",
  schedulingSpecificDaysTitle: "Dias Específicos",
  schedulingSpecificDaysDescription: "Adicione datas específicas dentro do período da campanha",
  schedulingAddSpecificDateLabel: "Adicionar Data Específica",
  schedulingProgrammedDatesTitle: "Datas Programadas",
  schedulingProgrammedDatesDescription:
    "Modo alternativo: defina datas específicas com horário fixo",
  schedulingAddProgrammedDateLabel: "Adicionar Data Programada",
  schedulingFixedTimeLabel: "Horário fixo",
  schedulingApplyButtonLabel: "Aplicar Agendamento",
  schedulingGeneratedDatesTitle: "Datas Agendadas",
  schedulingAddButtonLabel: "Adicionar",
  schedulingClearSchedulesButtonLabel: "Limpar envios",
  schedulingAddNewSendsTitle: "Adicionar Novos Envios",
  schedulingNoSchedulingConfiguredError: "Por favor, configure pelo menos uma opção de agendamento",
  schedulingNoDaysSelectedError:
    "Por favor, selecione pelo menos um dia da semana, dia específico ou data programada",
  schedulingNoHoursSelectedError: "Por favor, selecione pelo menos um horário de envio",
  schedulingDateInPastError:
    "A data e horário selecionados são do passado. Por favor, selecione uma data futura.",
  schedulingAllDatesInPastError:
    "Todas as datas selecionadas são do passado. Por favor, selecione pelo menos uma data futura.",
  schedulingDateOutOfRangeError: "A data selecionada está fora do período da campanha.",
};
